interface DocumentWithFullscreen extends Document {
   webkitCurrentFullScreenElement: Element;
   mozFullScreenElement?: Element;
   msFullscreenElement?: Element;
}

export const getIsFullscreen = () => document.fullscreenElement || (document as DocumentWithFullscreen).webkitCurrentFullScreenElement || (document as DocumentWithFullscreen).mozFullScreenElement;